const smallProjects = [
    {
        id: 12,
        title: "Add API for sampling statistics in NeST",
        hours: 90,
        brief: "NeST generates statistics from several utilities of Linux, including socket statistics (ss), traffic control (tc), netperf, ping, and others. It also produces plots based on these statistics. However, the sampling rate at which the statistics are collected from NeST is fixed to 200ms. There is a need for an API that allows the user to change this sampling rate. The main aim of this project is to build an easy-to-use API in NeST to configure the sampling rate. Previously, some work has been done towards this project, so a reference source code is available, but it might not be reliable.",
        mentor: "Shanthanu S. Rai",
        requiredExperience: "Python",
        bonusExperience: "Knowledge of the internals of NeST is a plus",
        difficulty: "Moderate",
        reading: [
            {
                title: "NeST APIs",
                link: "https://nest.l4.nitk.ac.in/docs/v0.3/api/api.html",
            },
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "An open issue in NeST repository",
                link: "https://gitlab.com/nitk-nest/nest/-/issues/156",
            },
        ],
    },
    {
        id: 13,
        title: "Enabling the support of DTLS in NeST",
        hours: 90,
        brief: "DTLS is a derivation of the SSL protocol. It provides security services (integrity, authentication, and confidentiality) and this protocol is often used on top of the UDP. The benefit of DTLS is that it provides end-to-end encryption, which means that data is encrypted on the client device and decrypted on the server device. Currently, NeST does not have the support of DTLS. The main goal of this project is to enable the support of DTLS in NeST.",
        requiredExperience: "Python",
        bonusExperience:
            "Knowledge of TLS and DTLS, and Network Namespaces is a plus.",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "RFC 4347",
                link: "https://www.rfc-editor.org/rfc/rfc4347",
            },
            {
                title: "Related issue on NeST's GitLab repo",
                link: "https://gitlab.com/nitk-nest/nest/-/issues/253",
            },
        ],
    },
    {
        id: 14,
        title: "Enabling the support of SCTP flows via iperf3 in NeST",
        hours: 90,
        brief: "iperf3 is a bandwidth measurement tool that can generate Internet-like traffic for live measurements. It is an extension to iperf. iperf and iperf3 are popular tools used for network experimentations, besides tools like netperf. NeST is a network emulator that provides easy-to-use Python APIs to spin different network topologies using network namespaces. Currently, iperf3 is supported in NeST, but there is no API to generate SCTP flows using iperf3 in NeST. The main goal of this project is to build an API that allows NeST users to generate SCTP traffic using iperf3.",
        mentor: "Shanthanu S. Rai",
        requiredExperience: "Python",
        bonusExperience:
            "Knowledge of iperf, iperf3, and network namespaces is a plus",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            { title: "iperf3", link: "https://software.es.net/iperf/" },
        ],
    },
];

export default smallProjects;
